// Lightweight dev-only logger.
// In production builds (NODE_ENV === 'production'), these become no-ops
// so we don't leak debugging info or clutter the browser console.
// Use logError for caught exceptions; logWarn for recoverable issues.

export const logError = (...args) => {
  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line no-console
    console.error(...args);
  }
};

export const logWarn = (...args) => {
  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line no-console
    console.warn(...args);
  }
};
